import styled from 'styled-components';

const SectionHeading = styled.h5`
  color: var(--spectrum-global-color-gray-700);
  text-transform: uppercase;
  font-size: 11px;
  margin: var(--spectrum-global-dimension-size-150) 0;
`;

export default SectionHeading;
